// LT/EN switch backed by the Google Translate widget, like translate.tsx on the
// React pages. The choice lives in Google's "googtrans" cookie, so it carries
// over to the rest of the site.
const DEFAULT_LANG = "lt"

const cookieLang = () => {
  const match = /googtrans=([^;]+)/.exec(document.cookie)
  return match ? decodeURIComponent(match[1]).split("/").pop() : null
}

const setCookie = (value, expires) => {
  const host = window.location.hostname
  const parts = host.split(".")
  const domains = ["", host, parts.length > 2 ? `.${parts.slice(-2).join(".")}` : `.${host}`]
  domains.forEach((domain) => {
    document.cookie = `googtrans=${value}; path=/${domain ? `; domain=${domain}` : ""}${expires ? `; expires=${expires}` : ""}`
  })
}

export default function initTranslate(group) {
  const buttons = Array.from(group.querySelectorAll("[data-lang]"))
  const urlLang = new URLSearchParams(window.location.search).get("lang")
  const current = urlLang || cookieLang() || DEFAULT_LANG

  // Also tells the rest of the page (banner images) which language is showing.
  const markPressed = (lang) => {
    buttons.forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.lang === lang)))
    document.dispatchEvent(new CustomEvent("hv:language", { detail: lang }))
  }
  markPressed(current)

  const combo = () => document.querySelector(".goog-te-combo")

  const apply = (lang) => {
    if (lang === DEFAULT_LANG) {
      // Leaving a Google translation cleanly needs a reload without the cookie.
      setCookie("", "Thu, 01 Jan 1970 00:00:00 GMT")
      window.location.reload()
      return
    }
    setCookie(`/${DEFAULT_LANG}/${lang}`)
    const select = combo()
    if (!select) return window.location.reload()
    select.value = lang
    select.dispatchEvent(new Event("change"))
    markPressed(lang)
  }

  buttons.forEach((button) =>
    button.addEventListener("click", () => {
      const lang = button.dataset.lang
      if (lang !== (cookieLang() || DEFAULT_LANG)) apply(lang)
    })
  )

  window.googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      { pageLanguage: DEFAULT_LANG, includedLanguages: "en", autoDisplay: false },
      "google_translate_element"
    )
    // ?lang=en links translate the page as soon as the widget is ready.
    if (urlLang && urlLang !== DEFAULT_LANG && urlLang !== cookieLang()) {
      const wait = setInterval(() => {
        if (!combo()) return
        clearInterval(wait)
        apply(urlLang)
      }, 200)
      setTimeout(() => clearInterval(wait), 10000)
    }
  }

  const script = document.createElement("script")
  script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
  script.async = true
  document.body.appendChild(script)

  // Google Translate sometimes locks scrolling with an inline style on <html>.
  new MutationObserver(() => {
    const html = document.documentElement
    if (html.style.overflow === "hidden" || html.style.height) html.removeAttribute("style")
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["style"] })
}
